import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="relative w-full py-20 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <p className="text-sm font-label tracking-widest uppercase text-foreground-400 mb-4">
            About Superbuy Spreadsheet
          </p>
          <p className="text-lg md:text-xl text-foreground-600 max-w-2xl leading-relaxed">
            The Superbuy Spreadsheet is the most comprehensive, community-curated database of verified products
            available through Superbuy. With thousands of hand-picked items across 14 categories, detailed QC
            reports, and real shipping comparisons, we help buyers worldwide shop with absolute confidence.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center lg:text-left">
              <div className="font-heading text-4xl md:text-5xl font-extrabold text-foreground-900 mb-2">
                {stat.value}
              </div>
              <p className="text-sm text-foreground-500 font-medium tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}